module.exports = __webpack_public_path__ + "static/media/black-cat-icon.449fa9f8.png";